<template>
  <div class="fumei-app-page">
    <AppHeader />

    <!-- 顶部 Banner -->
    <main class="main-content fumei-hero scroll-animate">
      <div class="fumei-hero__bg" aria-hidden="true">
        <img :src="images.heroBg" alt="" />
      </div>
      <div class="fumei-hero__wave" aria-hidden="true"></div>

      <div class="fumei-hero__inner">
        <div class="fumei-hero__brand">肤美</div>
        <h1 class="fumei-hero__title">AI智能皮肤毛发管理专家</h1>
        <div class="fumei-hero__divider">
          <span class="fumei-hero__divider-line"></span>
          <span class="fumei-hero__divider-dot"></span>
          <span class="fumei-hero__divider-line"></span>
        </div>
        <p class="fumei-hero__subtitle">随时一拍 · 秒懂肌肤</p>

        <div class="fumei-hero__download">
          <div class="fumei-qr">
            <img :src="images.qrCode" alt="肤美APP下载二维码" />
          </div>
          <div class="fumei-stores">
            <div class="fumei-stores__grid">
              <span
                v-for="store in stores"
                :key="store"
                class="fumei-store-btn"
              >{{ store }}</span>
            </div>
            <p class="fumei-stores__tip">安卓六大主流应用市场全量上线</p>
          </div>
        </div>
      </div>
    </main>

    <!-- 四大功能亮点 -->
    <section class="fumei-features scroll-animate">
      <div
        v-for="feature in features"
        :key="feature.title"
        class="fumei-feature"
        :class="{ 'fumei-feature--reverse': feature.reverse }"
      >
        <div class="fumei-feature__phone">
          <img :src="feature.image" :alt="feature.title" />
        </div>
        <div class="fumei-feature__text">
          <h2>{{ feature.title }}</h2>
          <p>{{ feature.desc }}</p>
        </div>
      </div>
    </section>

    <!-- APP 界面展示 -->
    <section class="fumei-gallery scroll-animate">
      <div class="fumei-gallery__header">
        <span class="fumei-gallery__decor">{{ decorRight }}</span>
        <h2 class="fumei-gallery__title">APP 界面</h2>
        <span class="fumei-gallery__decor">{{ decorLeft }}</span>
      </div>
      <div class="fumei-gallery__banner">
        <img :src="images.gallery" alt="肤美APP界面合集" />
      </div>
    </section>

    <AppFooter />
  </div>
</template>

<script>
import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'
import { formatImg } from '@/utils/formatImg'
import { getPageImageMap } from '@/api/pageImages'
import { FUMEI_IMAGE_CODES } from '@/constants/pageImageCodes'

export default {
  name: 'FumeiApp',
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      decorRight: '>>>>>>>>>>>>>>>>>>>>>>>>>>',
      decorLeft: '<<<<<<<<<<<<<<<<<<<<<<<<',
      stores: ['华为', '荣耀', '小米', 'OPPO', 'vivo', '应用宝'],
      animatedElements: [],
      images: {
        heroBg: '',
        qrCode: '',
        gallery: ''
      },
      features: [
        {
          title: '秒级智能检测',
          desc: '无需预约、无需排队等候，打开 APP 随手一拍，AI 智能引擎即可实现秒级响应，快速完成皮肤状态智能分析，让你足不出户，即刻精准掌控自身皮肤健康状况，轻松开启便捷高效的肌肤健康自测体验。',
          image: '',
          reverse: false
        },
        {
          title: 'AI深度学习算法',
          desc: '基于海量皮肤影像数据训练的深度神经网络，覆盖色素痣、银屑病、白癜风、脂溢性皮炎等 20+ 种常见皮肤问题，拍照即出专业级检测结果。',
          image: '',
          reverse: false
        },
        {
          title: '隐私安全保障',
          desc: '采用本地加密存储与数据脱敏双重处理，全程保障你的皮肤检测数据安全与隐私。从拍摄分析到结果存储，所有肌肤数据仅对你个人开放，绝不外泄、不被滥用，让你安心享受智能皮肤检测服务。健康隐私双重守护。',
          image: '',
          reverse: true
        },
        {
          title: '专业医疗机构',
          desc: '精准定位你所在城市，严选本地正规合作医美机构与资深医师团队。资质齐全、口碑可查。足不出户即可查看机构详情、医生履历与擅长项目。安心预约、就近变美，让专业医美服务触手可及。',
          image: '',
          reverse: true
        }
      ]
    }
  },
  mounted() {
    // 与产品详情页一致：进页置顶 + 滚动入场动画
    window.scrollTo({ top: 0, behavior: 'auto' })
    this.loadPageImages()
    this.initScrollReveal()
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    async loadPageImages() {
      try {
        const map = await getPageImageMap('fumei')
        if (!map || typeof map !== 'object') return

        const pick = (code) => formatImg(map[code] || '')

        this.images.heroBg = pick(FUMEI_IMAGE_CODES.HERO_BG)
        this.images.qrCode = pick(FUMEI_IMAGE_CODES.QR)
        this.images.gallery = pick(FUMEI_IMAGE_CODES.GALLERY)
        this.features = this.features.map((feature, index) => ({
          ...feature,
          image: pick(FUMEI_IMAGE_CODES[`FEATURE_${index + 1}`])
        }))
      } catch (e) {
        console.error('加载肤美APP页面图片失败', e)
      }
    },

    initScrollReveal() {
      this.$nextTick(() => {
        this.animatedElements = document.querySelectorAll('.fumei-app-page .scroll-animate')
        this.checkScrollPosition()
        window.addEventListener('scroll', this.handleScroll)
      })
    },

    handleScroll() {
      this.checkScrollPosition()
    },

    checkScrollPosition() {
      const windowHeight = window.innerHeight
      const revealPoint = 150

      this.animatedElements.forEach((element, index) => {
        if (!element || element.classList.contains('visible')) return

        const elementTop = element.getBoundingClientRect().top
        if (elementTop < windowHeight - revealPoint) {
          setTimeout(() => {
            element.classList.add('visible')
          }, index * 300)
        }
      })
    }
  }
}
</script>

<style scoped>
.fumei-app-page {
  width: 100%;
  background: #fff;
}

/* 与产品页一致的滚动入场动画 */
.scroll-animate {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s ease-out;
}

.scroll-animate.visible {
  opacity: 1;
  transform: translateY(0);
}

.fumei-feature {
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.6s ease-out;
}

.fumei-features.visible .fumei-feature {
  opacity: 1;
  transform: translateY(0);
}

.fumei-feature:nth-child(1) { transition-delay: 0.1s; }
.fumei-feature:nth-child(2) { transition-delay: 0.2s; }
.fumei-feature:nth-child(3) { transition-delay: 0.3s; }
.fumei-feature:nth-child(4) { transition-delay: 0.4s; }

/* ========== Hero Banner ========== */
.fumei-hero {
  position: relative;
  overflow: hidden;
  background: #2e5fac;
  color: #fff;
  padding: 7rem 0 4rem;
  text-align: left;
  min-height: 32rem;
}

.fumei-hero__bg {
  position: absolute;
  inset: 0;
  opacity: 0.18;
  pointer-events: none;
}

.fumei-hero__bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.fumei-hero__wave {
  position: absolute;
  right: -8%;
  bottom: -18%;
  width: 55%;
  height: 55%;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 50% 50% 0 50%;
  transform: rotate(-18deg);
  pointer-events: none;
}

.fumei-hero__inner {
  position: relative;
  z-index: 1;
  width: min(90rem, 96%);
  margin: 0 auto;
}

.fumei-hero__brand {
  margin-bottom: 2rem;
  font-size: clamp(2rem, 3.5vw, 2.75rem);
  font-weight: 700;
  letter-spacing: 0.18em;
}

.fumei-hero__title {
  margin: 0;
  font-size: clamp(1.75rem, 3.2vw, 2.75rem);
  font-weight: 700;
  line-height: 1.35;
  color: #fff;
  text-align: center;
}

.fumei-hero__divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  margin: 1.1rem 0 0.9rem;
}

.fumei-hero__divider-line {
  display: block;
  width: 4.5rem;
  height: 1px;
  background: rgba(255, 255, 255, 0.75);
}

.fumei-hero__divider-dot {
  width: 0.35rem;
  height: 0.35rem;
  border-radius: 50%;
  background: #fff;
}

.fumei-hero__subtitle {
  margin: 0 0 2.75rem;
  font-size: clamp(1rem, 1.6vw, 1.35rem);
  letter-spacing: 0.12em;
  text-align: center;
  opacity: 0.95;
}

.fumei-hero__download {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.fumei-qr {
  width: 9.5rem;
  height: 9.5rem;
  padding: 0.45rem;
  background: #fff;
  border-radius: 0.65rem;
  box-sizing: border-box;
  flex-shrink: 0;
}

.fumei-qr img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}

.fumei-stores {
  text-align: center;
}

.fumei-stores__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(6.5rem, 1fr));
  gap: 0.7rem 0.85rem;
  justify-items: center;
}

.fumei-store-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 6.5rem;
  min-height: 2.4rem;
  padding: 0.45rem 1.25rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.88);
  color: #333;
  font-size: 0.95rem;
}

.fumei-stores__tip {
  margin: 0.9rem 0 0;
  font-size: 0.92rem;
  opacity: 0.92;
  text-align: center;
}

/* ========== Features ========== */
.fumei-features {
  width: min(90rem, 96%);
  margin: 0 auto;
  padding: 4.5rem 0 2.5rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem 3rem;
}

.fumei-feature {
  display: flex;
  align-items: center;
  gap: 1.75rem;
  text-align: left;
}

.fumei-feature--reverse {
  flex-direction: row-reverse;
}

.fumei-feature__phone {
  flex: 0 0 22rem;
  width: 22rem;
  border-radius: 1.25rem;
  overflow: hidden;
  background: #f5f8fc;
  box-shadow: 0 10px 28px rgba(13, 95, 184, 0.12);
}

.fumei-feature__phone img {
  width: 100%;
  height: auto;
  display: block;
}

.fumei-feature__text h2 {
  margin: 0 0 0.85rem;
  color: #0d5fb8;
  font-size: 1.55rem;
  font-weight: 700;
}

.fumei-feature__text p {
  margin: 0;
  color: #555;
  font-size: 1rem;
  line-height: 1.85;
  text-indent: 2em;
}

/* ========== Gallery ========== */
.fumei-gallery {
  width: min(90rem, 96%);
  margin: 0 auto;
  padding: 2rem 0 5rem;
}

.fumei-gallery__header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.fumei-gallery__title {
  margin: 0;
  color: #0d5fb8;
  font-size: 1.75rem;
  font-weight: 700;
  white-space: nowrap;
}

.fumei-gallery__decor {
  color: #7eb6ea;
  font-size: 0.85rem;
  letter-spacing: -0.05em;
  opacity: 0.85;
  user-select: none;
}

.fumei-gallery__banner img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 0.5rem;
}

/* ========== Responsive ========== */
@media (max-width: 960px) {
  .fumei-hero {
    padding: 6.5rem 0 3rem;
    min-height: auto;
  }

  .fumei-features {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }

  .fumei-feature,
  .fumei-feature--reverse {
    flex-direction: column;
    text-align: center;
  }

  .fumei-feature__phone {
    flex-basis: auto;
    width: 18rem;
  }

  .fumei-gallery__decor {
    display: none;
  }
}

@media (max-width: 640px) {
  .fumei-hero__download {
    flex-direction: column;
    align-items: flex-start;
  }

  .fumei-stores__grid {
    grid-template-columns: repeat(2, minmax(6rem, 1fr));
  }

  .fumei-feature__phone {
    width: 15rem;
  }
}
</style>
